import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForEAtoOSBNonRTPremiumAndRTPredunning(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		isInReverseTrial,
		isInCollection,
		invoiceableStatus,
		canAddPaymentDetails,
		addPaymentDetailsExperienceUrl,
	} = context;

	const isRTPredunningAudience =
		isInReverseTrial && isInPredunning && (product === 'jira' || product === 'confluence');

	const isNonRTTrialAudience =
		!isInReverseTrial &&
		((product === 'jira' && isInTrial) ||
			(product === 'confluence' && (isInTrial || isInPredunning)));

	return Boolean(
		isInCollection === 'NOT_IN_COLLECTION' &&
		edition === 'premium' &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails &&
		!!addPaymentDetailsExperienceUrl &&
		(isRTPredunningAudience || isNonRTTrialAudience),
	);
}
